<template>
    <div class="crud-wrapper">

        <v-layout row wrap>
            <v-flex column xs12 pb-4>
                <label class="title font-weight-bold grey--text">Configurações Ativas para Discador</label>
            </v-flex>

            <v-flex column xs12 sm4 pr-4>
                <label class="v-label v-label--active theme--light aLabel mb-3">Ramais</label>
                <v-scale-transition group>
                    <template v-for="r in ramais">
                        <v-chip :key="r">
                            {{r}}
                        </v-chip>
                    </template>
                </v-scale-transition>
            </v-flex>
            <v-flex column xs12 sm4 pr-3>
                <label class="v-label v-label--active theme--light aLabel mb-3">Tabulações</label>
                <v-scale-transition group>
                    <template v-for="status in callStatus">
                        <v-chip :key="status.id" :color="statusColor(status)">
                            {{status.name}}
                        </v-chip>
                    </template>
                </v-scale-transition>
            </v-flex>
            <v-flex xs12 sm4>
                <label class="v-label v-label--active theme--light aLabel mb-3">Pausas</label>
                <v-scale-transition group>
                    <template v-for="status in employeeStop">
                        <v-chip :key="status.id">
                            {{status.name}}
                        </v-chip>
                    </template>
                </v-scale-transition>
            </v-flex>

        </v-layout>

    </div>
</template>

<script>
    // import numeral from 'numeral';
    // import CrudFormClass from "@consigmais-team/vue-common/layout/crudPage/crudFormClass";
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';

    export default PageClass.extend({

        name: 'AutoDialer',

        data () {
            return {
                title: 'Discador',
                formName: 'autoDialer',

                formData: {
                    id: null,
                    companyId: this.$store.state.company.selectedStore,
                    done_at: null,
                    typeId: -1,
                    amount: 0,
                    notes: null
                },

                ramais: ['101: Francielle','102: Mariana','103','104','105']

            };
        },

        computed: {
            callStatus() {
                return this.$store.state.company.lookups.callStatus;
            },

            employeeStop() {
                return this.$store.state.company.lookups.employeeStop;
            },

            userName () {
                return this.$store.state.company.user.name;
            }

        },

        methods: {
            statusColor(status) {
                if (status.id > 50) return 'red lighten-3';
                else if (status.id > 20) return 'amber lighten-3';
                else return '';
            },

            saveConfirmation () {
                return new Promise((resolve, reject) => {
                    this.$msg.confirm({
                        title: 'Abrir Caixa',
                        message: `Confirma abertura com ${this.formData.amount} ?`,
                        actions: ['Sim', 'Não'],
                        defaultAction: 1
                    }).then((action) => (action === 0) ? resolve(true) : reject(false));
                });
            }
        }

    });

</script>

<style scoped>


</style>








// WEBPACK FOOTER //
// src/pages/AutoDialer.vue